const payoutTable = {
  1: {
    0: 0,
    1: 3.0,
  },

  2: {
    0: 0,
    1: 1.0,
    2: 10.0,
  },

  3: {
    0: 0,
    1: 0,
    2: 2.0,
    3: 40.0,
  },

  4: {
    0: 0,
    1: 0,
    2: 1.0,
    3: 6.0,
    4: 80.0,
  },

  5: {
    0: 0,
    1: 0,
    2: 0,
    3: 3.0,
    4: 18.0,
    5: 300.0,
  },

  6: {
    0: 0,
    1: 0,
    2: 0,
    3: 1.5,
    4: 8.0,
    5: 70.0,
    6: 700.0,
  },

  7: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 4.0,
    5: 20.0,
    6: 180.0,
    7: 1800.0,
  },

  8: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 1.0,
    5: 12.0,
    6: 70.0,
    7: 500.0,
    8: 4000.0,
  },

  9: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 7.0,
    6: 45.0,
    7: 300.0,
    8: 1700.0,
    9: 7000.0,
  },

  10: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 4.0,
    6: 35.0,
    7: 220.0,
    8: 1200.0,
    9: 4500.0,
    10: 18000.0,
  },
};

module.exports = payoutTable;
